export default __webpack_public_path__ + "0a5e3243e26905eb4714197770c22e2f.svg";